import { CompositeFilter } from 'simple-logging-lib';
import { RequestTimeoutFilter } from './RequestTimeoutFilter';
import { SessionTimeoutFilter } from './SessionTimeoutFilter';
import { ErrorLevelFilter } from './ErrorLevelFilter';
import { RedirectionInProgressFilter } from './RedirectionInProgressFilter';
import { ChunkLoadFilter } from './ChunkLoadFilter';
export const defaultErrorLogFilter = new CompositeFilter(new ErrorLevelFilter(), new RedirectionInProgressFilter(), new RequestTimeoutFilter(), new SessionTimeoutFilter(), new ChunkLoadFilter());